import React, { useState } from 'react';
import './ThirdStep.scss';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useAccount } from '../../../../../shared/contexts/account/AccountContexts';
import { useProjectWizard } from '../../contexts/ProjectWizardContext';
import Loader from '../../../../../shared/components/common/loader/Loader';
import { useProjectSubmit } from '../../hooks/UseProjectSubmit';

const ThirdStep: React.FC = () => {
  const { submitProject } = useProjectSubmit();
  const [apiError, setApiError] = useState<string | null>(null);
  const { activeStep, setActiveStep, projectData, searchVolume, questionResponse, setQuestionResponse } =
    useProjectWizard();
  const { accountResponse, refetchData } = useAccount();
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleSubmit = async () => {
    if (isSubmitting) {
      return;
    }

    if (activeStep !== 'SEARCH_VOLUME') {
      return;
    }

    if (!projectData || projectData.questions.length === 0) {
      setApiError(t('selectMinimumOne'));
      return;
    }

    setApiError(null);
    setIsSubmitting(true);

    try {
      const projectsResponseData = await submitProject(projectData);
    } catch (err: any) {
      setApiError(err.response.data.error || t('unexpectedError'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const backToQuestion = () => {
    if (
      !projectData ||
      projectData.questions.length <= 0 ||
      !questionResponse ||
      questionResponse.brand.trim() === ''
    ) {
      setActiveStep('QUESTIONS');
      return;
    }

    setQuestionResponse({
      ids: questionResponse.ids,
      questions: projectData.questions,
      brand: projectData.firmName,
      projectCountry: projectData.projectCountry,
    });
    setActiveStep('QUESTIONS');
  };

  return (
    <div className="project-wizard__page-box project-wizard__page-box--question">
      {isSubmitting && <Loader loadingLabel="loadingDataThisMayTakeAMoment" />}

      <div className="project-wizard__form">
        <div className="form-box__row">
          <h2>{t('searchVolumeForSelectedQuestions')}:</h2>
          <div className="form-table">
            <div className="form-table__row form-table__row--header">
              <div>{t('question')}:</div>
              <div>{t('searchVolume')}:</div>
            </div>
            {searchVolume?.map((searchVolumeData, index) => (
              <div className="form-table__row" key={`question-${index}`}>
                <div>
                  {searchVolumeData.question}
                  {accountResponse?.isSuperAdmin && !accountResponse?.isLimitedSuperAdmin && (
                    <span>{searchVolumeData.phrase}</span>
                  )}
                </div>
                <div>
                  {searchVolumeData.searchVolume > 100
                    ? Intl.NumberFormat('pl-PL').format(searchVolumeData.searchVolume)
                    : '<100'}
                </div>
              </div>
            ))}
          </div>
          {apiError && <span className="error-message">{apiError}</span>}
        </div>
      </div>

      <div className="project-wizard__action project-wizard__action--inline">
        <Button
          onClick={backToQuestion}
          type="submit"
          className="btn btn--secondary btn--sm"
          disabled={isSubmitting}
        >
          {t('back')}
        </Button>
        <Button onClick={handleSubmit} type="submit" className="btn btn--sm" disabled={isSubmitting}>
          {t('saveAndLaunch')}
        </Button>
      </div>
    </div>
  );
};

export default ThirdStep;
